
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/panels/messagePanels/publishingBlocked/publishingBlockedForUser.scss.css.virtualfile';
        module.exports = {"root":"_root_1uq9z_1"};